export default __webpack_public_path__ + "static/media/armbands_of_tribulation.86abdfa3.jpg";